class PhoneValidator {
  constructor(country) {
    this.validCountry = ['ru', 'kz'];
    this.country = country;
  }

  IsValidCountry() {
    if(this.validCountry.indexOf(this.country) === -1) return false;
    return true;
  }

  Valid(phoneNumber) {
    if(!this.IsValidCountry()) return false;

    const number = phoneNumber.replace(/[^\d]/g, '');

    if(number.length != 11) return false;
    if(this.country === "ru") {
      return (number.charAt(0) == 7) && !(number.substr(0,2) == 77 || number.substr(0,2) == 76);
    } else if(this.country === "kz") {
      return (number.substr(0,2) == 77 || number.substr(0,2) == 76);
    }
  }

  out_error() {
    if (this.country === "ru") {
      toastr.error("Введите российский номер");
    } else if(this.country === "kz") {
      toastr.error("Введите казахский номер");
    }
  }
}

export default PhoneValidator;